import {Injectable} from '@angular/core';
import {Bank} from '../model/bank.model';
import {HttpClient} from '@angular/common/http';
import {ApiServiceService} from '../api-service.service';

@Injectable()
export class BankService {
    constructor(private httpClient: HttpClient, private apiService: ApiServiceService) {
    }

    public async findByIfsc(code: string): Promise<Bank> {
        const url = this.apiService.baseURL() + `bank-branch?ifsc=${code}`;
        return this.httpClient.get<Bank>(url).toPromise();
    }

    public async getBankList(): Promise<string[]> {
        const url = this.apiService.baseURL() + 'bankLists';
        const response = await this.httpClient.post<any>(url, {}).toPromise();
        return response.result.bank_list.map(b => b.bank_name);
    }

    public async getCityList(bankName: string): Promise<string[]> {
        const url = this.apiService.baseURL() + 'searchBankCity';
        const response = await this.httpClient.post<any>(url, {bank_name: bankName}).toPromise();
        return response.result.map(c => c.city_name);
    }

    public async getBranchNamesByBankNameAndCity(bankName: string, city: string): Promise<string[]> {
        const url = this.apiService.baseURL() + 'getBankBranch';
        const response = await this.httpClient.post<any>(url, {
            bank_name: bankName,
            city: city
        }).toPromise();
        return response.result.map(b => b.branch_name);
    }

    public async getIfscByBranchAndBankName(branchName: string, bankName: string): Promise<string> {
        const url = this.apiService.baseURL() + 'getBankIfcs';
        const response = await this.httpClient.post<any>(url, {
            branch_name: branchName, bank_name: bankName
        }).toPromise();
        return response.result.IFSC;
    }
}
